import React from 'react'
import './Button.css'

export default ({ onClick, children }) => (
  <button className="btn" onClick={onClick}>
    {children}
  </button>
)
